<template>
  <v-container>
    <Header />
    <v-overlay :value="bookingLoader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      top
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="mx-auto" max-width="400" v-if="bookings.length == 0">
      <v-toolbar flat>
        <v-toolbar-title class="grey--text align-center"
          >Manage my bookings</v-toolbar-title
        >
        <div class="flex-grow-1"></div>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-alert type="error" v-model="message.showError">{{
          message.errorMessage
        }}</v-alert>
        <v-form ref="formManageBooking">
          <v-text-field
            v-model="booking.firstName"
            label="Your first name"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
          <v-text-field
            v-model="booking.lastName"
            label="Your last name"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
          <v-text-field
            v-model="booking.email"
            label="Email address"
            :rules="[rules.required, rules.email]"
            outlined
          ></v-text-field>
          <v-btn
            depressed
            large
            block
            class="managebookingsbutton hp--btn"
            @click="manageBooking"
            >Continue</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mx-auto" max-width="1000" v-if="bookings.length > 0">
      <v-toolbar flat>
        <v-toolbar-title class="grey--text"
          >Manage your bookings</v-toolbar-title
        >
        <div class="flex-grow-1"></div>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-alert type="error" v-model="message.showError">{{
          message.errorMessage
        }}</v-alert>
        <v-card flat v-for="booking in bookings" :key="booking.id">
          <v-layout class="pa-3">
            <v-flex xs12 sm12 md2 lg2 xl2>
              <div class="caption grey--text">Service</div>
              <div>{{ booking.service }}</div>
            </v-flex>
            <v-flex xs12 sm12 md2 lg2 xl2>
              <div class="caption grey--text">Name</div>
              <div>{{ booking.firstname }} {{ booking.lastname }}</div>
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 xl3>
              <div class="caption grey--text">Email</div>
              <div>{{ booking.email }}</div>
            </v-flex>
            <v-flex xs12 sm12 md2 lg2 xl2>
              <div class="caption grey--text">Appointment</div>
              <div>
                {{ booking.date | moment("Do MMM YYYY") }} {{ booking.slot }}
              </div>
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 xl3>
              <div>
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="success"
                      class="mr-2 white--text"
                      v-on="on"
                      v-bind="size"
                      @click="
                        resendEmail(
                          booking.id,
                          booking.iCalendar,
                          booking.time,
                          booking.date,
                          booking.company,
                          booking.event,
                          booking.room,
                          booking.firstname,
                          booking.lastname,
                          booking.email,
                          booking.mobile,
                          booking.bloodDropStart,
                          booking.bloodDropEnd,
                          booking.urinePotLocation,
                          booking.commsTemplate
                        )
                      "
                    >
                      Resend
                      <v-icon right dark class="hidden-sm-and-down"
                        >mdi-email</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Send reminder email</span>
                </v-tooltip> -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="error"
                      class="ma-2 white--text"
                      v-on="on"
                      v-bind="size"
                      @click="
                        cancelAppointment(
                          booking.id,
                          booking.eventSlotId,
                          booking.iCalendar,
                          booking.type,
                          booking.email,
                          booking.firstname,
                          booking.room,
                          booking.time,
                          booking.date,
                          booking.company,
                          booking.event,
                          booking.booked
                        )
                      "
                    >
                      Cancel
                      <v-icon right dark class="hidden-sm-and-down"
                        >mdi-calendar-remove</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Cancel appointment</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-card>
      </v-card-text>
    </v-card>
    <Footer />
  </v-container>
</template>

<script>
import { API } from "aws-amplify";
import { Booking } from "../classes/Booking";
import Footer from "../components/Footer.vue";
import Header from "../components/Header.vue";
export default {
  data() {
    return {
      bookingLoader: false,
      booking: [],
      bookings: [],
      nextToken: null,
      message: {
        showError: false,
        errorMessage: null,
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
        show: false,
        message: null,
      },
      rules: {
        required: (v) => !!v || "This field is required.",
        email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      },
    };
  },
  components: {
    Footer,
    Header
  },
  methods: {
    async manageBooking() {
      if (this.$refs.formManageBooking.validate()) {
        this.message.showError = false;
        this.bookingLoader = true;
        const searchQuery =
          this.booking.firstName.toLowerCase() +
          " " +
          this.booking.lastName.toLowerCase() +
          " " +
          this.booking.email.toLowerCase();
        const body = { searchQuery: searchQuery };
        const bookings = await API.post(
          "lsLambdaPublicQueryApi",
          "/query/findUserBookings",
          {
            body
          }
        );
        this.bookings = bookings.data;
        this.bookingLoader = false;
        if (this.bookings.length === 0) {
          this.showErrorMessage(
            "No bookings found for this name and email address"
          );
        }
      }
    },
    async cancelAppointment(
      bookingId,
      eventSlotId,
      iCalendar,
      type,
      email,
      firstname,
      room,
      time,
      date,
      company,
      event,
      booked
    ) {
      const result = confirm(
        "Are you sure you want to cancel this appointment?"
      );

      if (result) {
        this.bookingLoader = true;
        const result = await Booking.cancelBooking({
          bookingId: bookingId,
          slotId: eventSlotId,
          iCalendar: iCalendar,
          type: type,
          email: email,
          firstname: firstname,
          room: room,
          time: time,
          date: date,
          company: company,
          event: event,
          booked: booked,
        });
        if (result.success === "Email sent successfully") {
          this.showSuccessMessage("Booking cancelled");
          this.bookings = this.bookings.filter(
            (booking) => booking.id !== bookingId
          );
          this.bookingLoader = false;
        } else {
          this.showErrorMessage(result.err.message);
          this.bookingLoader = false;
        }
      }
    },
    async resendEmail(
      bookingId,
      iCalendar,
      time,
      date,
      company,
      event,
      room,
      firstname,
      lastname,
      email,
      mobile,
      bloodDropStart,
      bloodDropEnd,
      urinePotLocation,
      commsTemplate
    ) {
      this.bookingLoader = true;
      const bookingEmail = await Booking.sendBookingEmail({
        slotTime: time,
        eventDate: date,
        company: company,
        event: event,
        room: room,
        firstname: firstname,
        lastname: lastname,
        email: email,
        mobile: mobile,
        iCalendar: iCalendar,
        bloodDropStart: bloodDropStart,
        bloodDropEnd: bloodDropEnd,
        urinePotLocation: urinePotLocation,
        commsTemplateId: commsTemplate,
      });
      this.bookingLoader = false;
      if (bookingEmail.success === "Email sent successfully") {
        this.showSuccessMessage("Reminder email sent");
      } else {
        this.showErrorMessage(bookingEmail.err.message);
      }
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    },
    showErrorMessage(message) {
      this.message = {
        showError: false,
        errorMessage: null,
      };
      this.message.errorMessage = message;
      this.message.showError = true;
    }
  },
  computed: {
    size() {
      const size = { xs: "x-small", sm: "x-small", md: "x-small", lg: "small" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
  },
};
</script>